import axios from "axios";
import router from "../router/index";
import {
    showFullScreenLoading,
    tryHideFullScreenLoading
} from "../loading";
import store from "../store";
import Vue from "vue";
// axios 配置
axios.defaults.timeout = 3 * 60 * 1000; //3分钟
axios.defaults.withCredentials = true;
axios.create({
    headers: {
        "Content-Type": "application/json",
        'Access-Token': window.localStorage.getItem('token') // headers塞token
    },
    // withCredentials: false
});

// http request 拦截器
axios.interceptors.request.use(
    config => {
        if (localStorage.getItem("token")) {
            config.headers['Access-Token'] = localStorage.getItem('token')
        }

        if (localStorage.getItem('Lesson')) {
            config.headers['Access-Lesson'] = localStorage.getItem('Lesson')

        }
        if (localStorage.getItem('Role')) {
            config.headers['Access-Role'] = localStorage.getItem('Role')
        }


        //showFullScreenLoading()
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
let isRefreshing = false
let requests = []
// http response 拦截器
axios.interceptors.response.use(response => {

        if (response.data.status === 401) {
            const config = response.config
            if (!isRefreshing) {
                isRefreshing = true
                return axios.post('/common/User/refreshToken').then(res => {
                    console.log(res)
                    if(res.data.status === 200){
                        const token  = res.data.data

                        localStorage.setItem("token", token);
                        config.headers['Access-Token'] = token
                        // 已经刷新了token，将所有队列中的请求进行重试
                        requests.forEach(cb => cb(token))
                        requests = []
                        return axios(config)
                    } else {
                        localStorage.clear();
                        //提示信息
                        Vue.prototype.$message.error(res.data.message);
                        setTimeout(() => {
                            router.push("/");
                            store.commit("setisLogin", 1);
                        }, 1000);

                    }
                }).catch(res => {
                    console.error('refreshToken error =>', res)

                }).finally(() => {
                    isRefreshing = false
                })

            } else {
                // 正在刷新token，将返回一个未执行resolve的promise
                return new Promise((resolve) => {
                    // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
                    requests.push((token) => {
                        config.baseURL = ''
                        config.headers['Access-Token'] = token
                        resolve(axios(config))
                    })
                })
            }

        } else if(response.data.status === 402){
            localStorage.clear();
            //提示信息
            Vue.prototype.$message.error(response.data.message);
            setTimeout(() => {
                router.push("/");
                store.commit("setisLogin", 1);
            }, 1000);
        }
        tryHideFullScreenLoading();
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    localStorage.removeItem("token");
                    localStorage.removeItem("username");
                    localStorage.removeItem("uid");
                    localStorage.removeItem("usinfo");
                    // 401 清除token信息并跳转到登录页面
                    // store.commit("hintMsg", "请重新登录");
                    // store.commit("hintShow", 1000);
                    Vue.prototype.$message.error("请重新登录");
                    setTimeout(() => {
                        router.push("/");
                        store.commit("setisLogin", 1);
                        //router.replace({
                        //name: "login",
                        //params: { redirect: router.currentRoute.fullPath }
                        // });
                    }, 1000);
                    break;
                case 504:
                    Vue.prototype.$message.error("请重新登录");
                    break;
                default:
                    //router.push("/404");
            }
        } else {
            //router.push("/404");
        }
        //console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
        return Promise.reject(error);
    }
);

export default axios;


// WEBPACK FOOTER //
// ./src/axios/axios.js